import _styled from "@emotion/styled-base";
import React from 'react';
import Icon from "./Icon";
import { buttons, colors, colorsRaw, shadows } from "./styles";
import { jsx as ___EmotionJSX } from "@emotion/core";
const sizes = {
  small: '28px',
  large: '40px'
};

const ButtonRound = _styled("button", {
  target: "e32dhqu0",
  label: "ButtonRound"
})(buttons.button, ";", shadows.dropMiddle, ";background-color:", colorsRaw.white, ";color:", props => colors[props.isActive ? `active` : `inactive`], ";border-radius:32px;display:flex;justify-content:center;align-items:center;width:", props => sizes[props.size], ";height:", props => sizes[props.size], ";padding:0;" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9JY29uQnV0dG9uLmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQVVpQyIsImZpbGUiOiIuLi8uLi9zcmMvSWNvbkJ1dHRvbi5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBSZWFjdCBmcm9tICdyZWFjdCc7XG5pbXBvcnQgc3R5bGVkIGZyb20gJ0BlbW90aW9uL3N0eWxlZCc7XG5pbXBvcnQgSWNvbiBmcm9tICcuL0ljb24nO1xuaW1wb3J0IHsgYnV0dG9ucywgY29sb3JzLCBjb2xvcnNSYXcsIHNoYWRvd3MgfSBmcm9tICcuL3N0eWxlcyc7XG5cbmNvbnN0IHNpemVzID0ge1xuICBzbWFsbDogJzI4cHgnLFxuICBsYXJnZTogJzQwcHgnLFxufTtcblxuY29uc3QgQnV0dG9uUm91bmQgPSBzdHlsZWQuYnV0dG9uYFxuICAke2J1dHRvbnMuYnV0dG9ufTtcbiAgJHtzaGFkb3dzLmRyb3BNaWRkbGV9O1xuICBiYWNrZ3JvdW5kLWNvbG9yOiAke2NvbG9yc1Jhdy53aGl0ZX07XG4gIGNvbG9yOiAke3Byb3BzID0+IGNvbG9yc1twcm9wcy5pc0FjdGl2ZSA/IGBhY3RpdmVgIDogYGluYWN0aXZlYF19O1xuICBib3JkZXItcmFkaXVzOiAzMnB4O1xuICBkaXNwbGF5OiBmbGV4O1xuICBqdXN0aWZ5LWNvbnRlbnQ6IGNlbnRlcjtcbiAgYWxpZ24taXRlbXM6IGNlbnRlcjtcbiAgd2lkdGg6ICR7cHJvcHMgPT4gc2l6ZXNbcHJvcHMuc2l6ZV19O1xuICBoZWlnaHQ6ICR7cHJvcHMgPT4gc2l6ZXNbcHJvcHMuc2l6ZV19O1xuICBwYWRkaW5nOiAwO1xuYDtcblxuZnVuY3Rpb24gSWNvbkJ1dHRvbih7IHNpemUsIGlzQWN0aXZlLCB0eXBlLCBvbkNsaWNrLCBjbGFzc05hbWUsIHRpdGxlIH0pIHtcbiAgcmV0dXJuIChcbiAgICA8QnV0dG9uUm91bmRcbiAgICAgIHNpemU9e3NpemV9XG4gICAgICBpc0FjdGl2ZT17aXNBY3RpdmV9XG4gICAgICBjbGFzc05hbWU9e2NsYXNzTmFtZX1cbiAgICAgIG9uQ2xpY2s9e29uQ2xpY2t9XG4gICAgICB0aXRsZT17dGl0bGV9XG4gICAgPlxuICAgICAgPEljb24gdHlwZT17dHlwZX0gc2l6ZT17c2l6ZX0gLz5cbiAgICA8L0J1dHRvblJvdW5kPlxuICApO1xufVxuXG5leHBvcnQgZGVmYXVsdCBJY29uQnV0dG9uO1xuIl19 */"));

function IconButton({
  size,
  isActive,
  type,
  onClick,
  className,
  title
}) {
  return ___EmotionJSX(ButtonRound, {
    size: size,
    isActive: isActive,
    className: className,
    onClick: onClick,
    title: title
  }, ___EmotionJSX(Icon, {
    type: type,
    size: size
  }));
}

export default IconButton;